import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  MatDateRangeInput,
  MatDateRangePicker,
  MatDatepickerToggle,
  MatEndDate,
  MatStartDate,
} from '@angular/material/datepicker';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';
import { find, get, isNil } from 'lodash';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { ResponseAgreementDto, UpdateAgreementDto } from '../../../../../../generated/apex-rest';
import { HistoryBackModule } from '../../directives/history-back/history-back.module';
import { ObjectSelectorModule } from '../../features/object/components/selector/object-selector.module';
import { MetaType } from '../../features/object/object.model';
import { AgreementRestService } from '../../features/object/project/agreement/agreement-rest.service';
import { AgreementService } from '../../features/object/project/agreement/agreement.service';
import { Project } from '../../features/object/project/project.model';
import { snack, snackErr } from '../../modules/snack.module';
import { FileUsageComponent } from '../file-usage/file-usage.component';
import { FileUsageModule } from '../file-usage/file-usage.module';
import { ModelRoleModule } from '../model-role/model-role.module';
import { ObjectFieldComponent } from '../object-field/object-field.component';
import { PageInfoModule } from '../page-info/page-info.module';
import { TextUsageModule } from '../text-usage/text-usage.module';
import { t } from '../translate/translate.function';
import { TranslateModule } from '../translate/translate.module';

@Component({
  selector: 'apex-agreement',
  templateUrl: './agreement.component.html',
  standalone: true,
  imports: [
    CommonModule,
    PageInfoModule,
    FormsModule,
    ObjectSelectorModule,
    TranslateModule,
    FileUsageModule,
    HistoryBackModule,
    ModelRoleModule,
    TextUsageModule,
    MatFormField,
    MatInput,
    CdkTextareaAutosize,
    MatCheckbox,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatLabel,
    MatStartDate,
    MatEndDate,
    MatSuffix,
    ObjectFieldComponent,
    MatButton,
  ],
  providers: [AgreementRestService],
})
export class AgreementComponent implements OnInit {
  constructor(
    private agreementRestService: AgreementRestService,
    private route: ActivatedRoute,
    private service: AgreementService,
  ) {}

  @ViewChild('fileUsage') fu: FileUsageComponent;
  @ViewChild('fileUsagePublic') fuPublic: FileUsageComponent;

  agreement: ResponseAgreementDto;
  MetaType = MetaType;
  project: Project;
  objectId: number;

  updateAgreement: UpdateAgreementDto;

  disabled$ = new BehaviorSubject<boolean>(true);

  ngOnInit(): void {
    void this.fetchAgreementData();
  }

  async fetchAgreementData(): Promise<void> {
    const params = await firstValueFrom(this.route.paramMap);
    const agreementId = params.get('id');

    this.agreement = await this.agreementRestService.read(Number(agreementId));
    this.project = await firstValueFrom(this.service.getTopLevelObject(Number(agreementId)));
    this.objectId = this.project.ParentId ?? this.project.id;

    const objects = await firstValueFrom(this.service.tree(Number(agreementId)));
    const responseObject = this.agreement.ObjectId;

    const parentId = get(find(objects, { id: Number(responseObject) }), 'ParentId');

    this.disabled$.next(this.agreement.role === 'involved' || (!isNil(parentId) && this.agreement.role !== 'involved'));
  }

  async save(): Promise<void> {
    this.updateAgreement = {
      ...this.agreement,
    };

    try {
      await this.agreementRestService.updateObjectField(this.agreement.id, this.updateAgreement);
      snack('Saved');
    } catch (e) {
      snackErr(t('Could not save'), e);
    }
  }
}
